

/*TICKET PAGE*/
Vue.component('ticketpage',{
    template:'#ticketpage-template',
    data:function(){
        return {
            baseURL:baseURL,
            Autolinker: Autolinker,
            project:[],
            ticket:[],
            dropZoneInstance:'',
            dropZoneFiles:[],
            user_activities:[],
            worktime_hours: '-1',
            worktime_minutes: '-1',
            posting_in_action: false,
            feed:[],
            maxFileSize: 80, /* MB */
            current_user_id:-1,
            comment_order:-1,
            comment_deadline_set:0,
            comment_deadline:'',
            modal:'',
            active_comment:'',
            active_tab: 'ticket',
            ticket_files: [],
            file_filter: '',
            file_filter_type: {
                ticket_brief: true,
                comment_file: true,
                project_brief: true
            },
            user_is_moderator: false,
            user_is_subscribed: null,
            user_is_assigned: false,
            task_completion: false,
            phase_list: [],
            phase_request: null,
            invoice_required: null,
            task_assigned:false,
            active_comment_id:null,
            post_type:"",  //comment,task
            task:{
                "title":"",
                "user_id":null,
                "deadline":null,
                "assignees":[]
            }
        };
    },
    watch: {
        active_tab: function() {
            if (this.active_tab == 'files') {
                if (this.ticket_files.length == 0) {
                    this.getTicketFiles();
                }

                return;
            }
            activeInstance.initDropZone();
            activeInstance.initEditor();
        },
        post_type:function(){
            if(activeInstance.post_type=="task"){
                setTimeout(function(){
                    flatpickr.localize(flatpickr.l10ns.hu);
                    $("#flatpickr").flatpickr(
                        {
                            enableTime: true,
                            dateFormat: "Y-m-d H:i",
                            "locale": {
                                "firstDayOfWeek": 1 // start week on Monday
                            },
                            time_24hr:true
                        }
                    );
                    activeInstance.initDropZone();
                },200);
            }
            else if(activeInstance.post_type=="comment_only"){
                setTimeout(function(){
                    activeInstance.initDropZone();
                },200);
            }
        }

    },
    created:function(){
        activeInstance = this;
        setTimeout(function(){
            var token = $("meta[name='csrf-token']").attr('content');

            activeInstance.modal = $('body').find('#edit_comment_deadline').html();

            //SET CURRENT USER ID BASED ON HIDDEN INPUT IN TEMPLATE
            activeInstance.current_user_id = $("#current_user_id").val();
            activeInstance.user_is_moderator = $("#user_is_moderator").val();
            activeInstance.user_is_account_manager = $("#user_is_account_manager").val();

            setTimeout(function(){
                $(function () {
                    $('#datetimepicker6').datetimepicker({
                        format: 'YYYY-MM-DD HH:00',
                        locale: 'hu',
                    });

                    $('#datetimepicker7').datetimepicker({
                        format: 'YYYY-MM-DD HH:00',
                        locale: 'hu',
                    });
                });
            },300);

            // Dropzone class
            activeInstance.initDropZone();
            activeInstance.initEditor();
            activeInstance.getUserActivities();
            activeInstance.getTicketData();
            activeInstance.loadPhaseList();

        },200);
    },
    events: {

    },
    methods: {
        onlyUnique:function(value, index, self) {
            return self.indexOf(value) === index;
        },
        editTaskDeadline:function(feed_record){
            console.log(feed_record);

            var checkbox_fields_html = '';
            $.each(activeInstance.ticket.assignees,function(index,assignee){

                var assignee_found = false;
                $.each(feed_record.task_data.tasks,function(subtask_index,subtask){
                    if(assignee.id==subtask.user_id){
                        assignee_found = true;
                    }
                });

                //CHECK IF ASSIGNEE IS CHECKED
                //IF YES
                if(assignee_found){
                    checkbox_fields_html +='' +
                        '<label class="label_container assignee ticket">\n' +
                        '<input checked type="checkbox" name="task_assignee_'+assignee.id+'">\n' +
                        '<span class="checkmark"></span>\n' +
                        '<span class="label comment_label">'+assignee.firstname+' '+assignee.lastname +'</span>\n' +
                        '</label>';
                }
                //IF NO
                else{
                    checkbox_fields_html +='' +
                        '<label class="label_container assignee ticket">\n' +
                        '<input type="checkbox" name="task_assignee_'+assignee.id+'" >\n' +
                        '<span class="checkmark"></span>\n' +
                        '<span class="label comment_label">'+assignee.firstname+' '+assignee.lastname +'</span>\n' +
                        '</label>';
                }


            });

            vex.dialog.open({
                input: [
                    /* TITLE */
                    '<h2 style="margin-top:10px;margin-bottom:30px;">Feladat módosítása</h2>',
                    /* DEADLINE */
                    '<fieldset style="margin-top:20px;margin-bottom: 0px;" class="form-group no_padding">',
                    '<label>Megnevezés</label>',
                    '<fieldset class="form-group no_padding">',
                    '<input id="" name="title" class="form-control" type="text" value="'+feed_record.task_data.tasks[0].title+'">',
                    '</fieldset>',
                    /* DEADLINE */
                    '<fieldset style="margin-top:20px;margin-bottom: 0px;" class="form-group no_padding">',
                    '<label>Határidő</label>',
                    '<fieldset class="form-group no_padding">',
                    '<input id="flatpickr-modal" name="deadline" class="form-control" type="text" value="'+feed_record.task_data.tasks[0].deadline+'">',
                    '</fieldset>',
                    '<div class="modal_heading">',
                    '<label>Felelősök</label>',
                    '</div>',
                    '<div class="assignee_list_modal">',
                    checkbox_fields_html,
                    '</div>',



                ].join(''),
                buttons: [
                    $.extend({}, vex.dialog.buttons.YES, {text: 'Rendben'}),
                    $.extend({}, vex.dialog.buttons.NO, {text: 'Mégse'})
                ],
                afterOpen: function () {
                    setTimeout(function () {
                        flatpickr.localize(flatpickr.l10ns.hu);
                        $("#flatpickr-modal").flatpickr(
                            {
                                enableTime: true,
                                dateFormat: "Y-m-d H:i",
                                "locale": {
                                    "firstDayOfWeek": 1 // start week on Monday
                                },
                                time_24hr:true
                            }
                        );
                    }, 300);

                },
                callback: function (data) {
                    if (!data) {
                        console.log('Cancelled');
                    }
                    else {
                        axios.post(baseURL+'/api/comment/task/update',{
                            'comment_id':feed_record.comment.id,
                            'modal_data':data
                        })
                        .then(function(){
                            feed_record.task_data.deadline  = data.deadline;
                            $.each(feed_record.task_data.tasks,function(index,task){
                                task.deadline = data.deadline;
                            });
                            activeInstance.getTicketData();
                            successNotification('A feladat részleteit frissítük.');
                        });

                    }
                }
            });
        },
        replyToTaskComment:function(comment_id){
            activeInstance.post_type='reply';
            activeInstance.active_comment_id=comment_id;

            $('#reply_editor_'+comment_id).trumbowyg({
                semantic: false,
                removeformatPasted: true,
                lang:'hu',
                btns:[
                    ['bold','underline','overline'],
                    ['strikethrough'],
                    ['italic'],
                    ['formatting'],
                    ['unorderedList', 'orderedList'],
                    ['indent'],
                    ['outdent'],
                    ['link'],
                    ['undo', 'redo']
                ]
            }).on('keydown keypress', function trumbowygKeydownKeypressEvent(event){
                if (event.keyCode === 9) { // tab key
                    event.preventDefault(); // prevent the tab key event from bubbling up
                    if(event.shiftKey){
                        $('#reply_editor_'+comment_id).trumbowyg('execCmd', {
                            cmd: 'outdent',
                            param: null,
                            forceCss: false,
                        });
                    }
                    else{
                        $('#reply_editor_'+comment_id).trumbowyg('execCmd', {
                            cmd: 'indent',
                            param: null,
                            forceCss: false,
                        });
                    }
                }
            });

            setTimeout(function(){
                $('#reply_editor_'+activeInstance.active_comment_id).css('background','#ffffff');
            });

            activeInstance.initReplyDropZone(comment_id);


        },
        subscribeClicked: function(event) {

            event.preventDefault();

            if (activeInstance.user_is_subscribed) {
                bootbox.confirm("Biztosan szeretnél leiratkozni az email értesítőről?", function(result) {
                    if (result) {
                        activeInstance.updateUserSubscribe();
                    }
                });
            } else {
                activeInstance.updateUserSubscribe();
            }
        },
        updateUserSubscribe: function() {

            axios.post(baseURL+'/api/ticket/subscribe/update', {
                ticket_id: activeInstance.ticket.id,
                subscribed: !activeInstance.user_is_subscribed
            })
            .then(function (response) {
                activeInstance.user_is_subscribed = response.data.subscribed;
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        updateCommentStatus:function(feed_record){
            axios.post('/api/ticket/status/update',{
                comment_id:feed_record.comment.id,
                completed:feed_record.comment.completed
            })
                .then(function(response){
                    successNotification("A feladat státusza módosítva.");
                });
        },
        uniqueTaskAssignees:function(task_list){
            var members = [];
            $.each(task_list,function(task_index,task){
                members.push(task.user.firstname+' '+task.user.lastname);
            });
            members = members.filter( activeInstance.onlyUnique );
            return members;
        },
        getUserSubscribed: function() {
            axios.get(baseURL+'/api/ticket/'+activeInstance.ticket.id+'/subscribe/get')
                .then(function (response) {
                    activeInstance.user_is_subscribed = response.data;

                    $('body').LoadingOverlay("hide");
                }).catch(function (error) {
                    console.log(error);
                    $('body').LoadingOverlay("hide");
            });
        },
        getTicketFiles: function() {
            showLoadingOverlay();

            axios.get(baseURL+'/api/ticket/'+activeInstance.ticket.id+'/files')
                .then(function (response) {
                    activeInstance.ticket_files = response.data;

                    setTimeout(function(){
                        $('body').LoadingOverlay("hide");
                    },100);
                }).catch(function (error) {
                    console.log(error);
                    $('body').LoadingOverlay("hide");
            });
        },
        toggleFilterType: function(values, state = null) {
            if (!Array.isArray(values)) {
                values = [values];
            }

            for(var i = 0, i_l = values.length; i < i_l; i ++) {
                this.file_filter_type[values[i]] = (state == null) ? !this.file_filter_type[values[i]] : state;
            }
        },
        filterFiles: function(arr) {
            console.log(arr);
            var new_arr = JSON.parse(JSON.stringify(arr)),
                that = this;

            new_arr = new_arr.filter(function(item) {
                return that.file_filter_type[item.type];
            });

            if (that.file_filter) {
                new_arr = new_arr.filter(function(item) {
                    return item.filename.toLowerCase().indexOf(that.file_filter.toLowerCase()) != -1;
                });
            }

            return new_arr;
        },
        initEditor: function() {
            $('#new_comment_editor').trumbowyg({
                semantic: false,
                removeformatPasted: true,
                lang:'hu',
                btns:[
                    ['bold','underline','overline'],
                    ['strikethrough'],
                    ['italic'],
                    ['formatting'],
                    ['unorderedList', 'orderedList'],
                    ['indent'],
                    ['outdent'],
                    ['link'],
                    ['undo', 'redo']
                ]
            }).on('keydown keypress', function trumbowygKeydownKeypressEvent(event){
                if (event.keyCode === 9) { // tab key
                    event.preventDefault(); // prevent the tab key event from bubbling up
                    if(event.shiftKey){
                        $('#new_comment_editor').trumbowyg('execCmd', {
                            cmd: 'outdent',
                            param: null,
                            forceCss: false,
                        });
                    }
                    else{
                        $('#new_comment_editor').trumbowyg('execCmd', {
                            cmd: 'indent',
                            param: null,
                            forceCss: false,
                        });
                    }
                }
            });
        },
        initDropZone: function() {
            // Dropzone class
            if (activeInstance.dropZoneInstance) {
                console.log(activeInstance.dropZoneInstance);
                activeInstance.dropZoneInstance[0].dropzone.destroy();
            }

            activeInstance.dropZoneInstance = $("body").dropzone({
                url: baseURL+'/admin/project/brief/file_upload',
                addRemoveLinks: true,
                maxFilesize: activeInstance.maxFileSize,
                clickable: "#dropzone",
                headers: {
                    'X-CSRF-TOKEN': token
                },
                addedfile: function(file) {
                    // Now attach this new element some where in your page
                },
                init: function() {
                    this.on("addedfile", function(file, response) {

                        // PREVENT FILE DUPLICATES
                        for (var i = 0, i_ = activeInstance.dropZoneFiles.length; i < i_; i ++) {
                            if (file.name == activeInstance.dropZoneFiles[i].name) {
                                errorNotification("Ezt a file-t már feltöltötted a kommenthez.");
                                return false;
                            }
                        }

                        if (file.size > activeInstance.maxFileSize * 1000000) {
                            errorNotification("Túl nagy file. Megengedett maximális méret: " + activeInstance.maxFileSize + "MB");
                            return;
                        }

                        //console.log(file);
                        //console.log(response);
                        var fileRecord = {};
                        fileRecord.name = file.name;
                        fileRecord.progress = 0;
                        fileRecord.bytesSent = 0;
                        fileRecord.file = file;
                        fileRecord.file_record_id = '';
                        activeInstance.dropZoneFiles.push(fileRecord);
                    });
                    this.on("success", function(file, response) {
                        $.each(activeInstance.dropZoneFiles,function(index,dropZoneFile){
                            if(dropZoneFile.name==file.name){
                                dropZoneFile.file_record_id=response;
                            }
                        });
                    });
                    this.on("uploadprogress", function(file) {
                        $.each(activeInstance.dropZoneFiles,function(index,dropZoneFile){
                            if(dropZoneFile.name==file.name){
                                dropZoneFile.progress=file.upload.progress;
                                dropZoneFile.bytesSent=file.upload.bytesSent;
                            }
                        });
                    });
                }
            });
            $('#dropzone').addClass('dropzone');
        },
        initReplyDropZone: function(comment_id) {
            // Dropzone class
            if (activeInstance.dropZoneInstance) {
                console.log(activeInstance.dropZoneInstance);
                activeInstance.dropZoneInstance[0].dropzone.destroy();
            }

            activeInstance.dropZoneInstance = $("body").dropzone({
                url: baseURL+'/admin/project/brief/file_upload',
                addRemoveLinks: true,
                maxFilesize: activeInstance.maxFileSize,
                clickable: "#dropzone_reply_"+comment_id,
                headers: {
                    'X-CSRF-TOKEN': token
                },
                addedfile: function(file) {
                    // Now attach this new element some where in your page
                },
                init: function() {
                    this.on("addedfile", function(file, response) {

                        // PREVENT FILE DUPLICATES
                        for (var i = 0, i_ = activeInstance.dropZoneFiles.length; i < i_; i ++) {
                            if (file.name == activeInstance.dropZoneFiles[i].name) {
                                errorNotification("Ezt a file-t már feltöltötted a kommenthez.");
                                return false;
                            }
                        }

                        if (file.size > activeInstance.maxFileSize * 1000000) {
                            errorNotification("Túl nagy file. Megengedett maximális méret: " + activeInstance.maxFileSize + "MB");
                            return;
                        }

                        //console.log(file);
                        //console.log(response);
                        var fileRecord = {};
                        fileRecord.name = file.name;
                        fileRecord.progress = 0;
                        fileRecord.bytesSent = 0;
                        fileRecord.file = file;
                        fileRecord.file_record_id = '';
                        activeInstance.dropZoneFiles.push(fileRecord);
                    });
                    this.on("success", function(file, response) {
                        $.each(activeInstance.dropZoneFiles,function(index,dropZoneFile){
                            if(dropZoneFile.name==file.name){
                                dropZoneFile.file_record_id=response;
                            }
                        });
                    });
                    this.on("uploadprogress", function(file) {
                        $.each(activeInstance.dropZoneFiles,function(index,dropZoneFile){
                            if(dropZoneFile.name==file.name){
                                dropZoneFile.progress=file.upload.progress;
                                dropZoneFile.bytesSent=file.upload.bytesSent;
                            }
                        });
                    });
                }
            });
            $('#dropzone_reply_'+comment_id).addClass('dropzone');
        },
        editComment:function(comment){

            activeInstance.active_comment = comment;

            bootbox.dialog({
                title: "Komment határidő szerkesztése",
                message: activeInstance.modal,
                buttons: {
                    success: {
                        label: "Save",
                        className: "btn-success",
                        callback: function () {

                            $('.field').removeClass('error');
                            var validation = true;

                            var deadline =  $('.modal-content').find('#comment_deadline').val();

                            if(validation == true){
                                activeInstance.$http.post(baseURL+'/admin/comment/update',{
                                    'comment_id':comment.id,
                                    'deadline': deadline
                                }).then(function(response){
                                    activeInstance.active_comment.deadline=deadline;
                                });
                            }else{
                                return false;
                            }
                        }
                    }
                }
            });

            setTimeout(function(){
                $(function () {
                    $('.modal-content').find('#datetimepicker7').datetimepicker({
                        format: 'YYYY-MM-DD HH:00',
                        locale: 'hu',
                    });

                    $('.modal-content').find('#comment_deadline').val(comment.deadline);
                });
            },700);
        },
        removeAccents:function(string){
            return RemoveAccents(string);
        },
        closeTicket:function(ticket){
            showLoadingOverlay();
            axios.post(baseURL+'/admin/project/ticket/close', {
                'ticket_id':ticket.id
            })
            .then(function (response) {
                console.log(response);
                ticket.status = 'closed';
                setTimeout(function(){
                    $('body').LoadingOverlay("hide");
                },200);
            })
            .catch(function (error) {
                console.log(error);
                $('body').LoadingOverlay("hide");
            });
        },
        humanDate:function($date){
            return moment($date).fromNow();
        },
        getFeedDataForTicket:function(){
            showLoadingOverlay();
            var ticket_id = $('#ticket_id').val();
            Vue.http.get(baseURL+'/api/ticket/feed/'+activeInstance.ticket.id).then(function(response){
            
                $('body').LoadingOverlay("hide");
                activeInstance.feed = response.data;
            }).bind(this);
        },
        jumpToLastComment:function() {
            activeInstance.active_tab = 'ticket';
            
            setTimeout(function() {
                $('html, body').animate({
                    scrollTop: $('.comment:last').offset().top-100
                }, 200);
            },200);
        },
        loadProjectDetails:function(){
            showLoadingOverlay();
                Vue.http.get(baseURL + '/api/project/list/one/'+activeInstance.ticket.project_id,function(response){
                $('body').LoadingOverlay("hide");
                console.log('project_data_response:');
                console.log(response);

                response.start = response.start.substring(0,10);
                response.deadline = response.deadline.substring(0,10);
                activeInstance.project = response;

                setTimeout(function(){
                    if(window.location.hash) {
                        var id = location.hash.replace('#','');

                        $('html, body').animate({
                            scrollTop: $('#'+id).offset().top-100
                        }, 200);

                    } else {
                        // Fragment doesn't exist
                    }

                    document.title=activeInstance.ticket.name+' - ODIN Enterprise Manager';
                    $("#page_title").text(activeInstance.project.brand.name.toUpperCase()+' / '+activeInstance.project.name.toUpperCase()+' / '+activeInstance.ticket.name.toUpperCase());

                },3000);
            });
        },
        //DELETE A FILE ATTACHMENT
        deleteFileAttachment:function(file){
            showLoadingOverlay();

            axios.post(baseURL+'/admin/project/brief/remove_uploaded_file_id', {
                file_record_id: file.file_record_id
            }).then(function (response) {
                $('body').LoadingOverlay("hide");
                activeInstance.dropZoneFiles.$remove(file);
            })
                .catch(function (error) {
                    $('body').LoadingOverlay("hide");
                    console.log(error);
                });
        },
        getTicketData:function(){

            var ticket_id = $('#ticket_id').val();
            showLoadingOverlay();
            Vue.http.get(baseURL+'/api/ticket/'+ticket_id).then(function(response){
                $('body').LoadingOverlay("hide");


                console.log('---');
                console.log(response.data.assignees);
                console.log('---');

                response.data.assignees.forEach(function(assignee){
                    assignee.selected = false;
                    console.log('#--');
                    console.log(assignee);
                    console.log('--#');
                });

                activeInstance.ticket = response.data;

                activeInstance.getUserSubscribed();

                for (var i = 0, i_ = activeInstance.ticket.assignees.length; i < i_; i ++) {
                    if (activeInstance.ticket.assignees[i].id == activeInstance.current_user_id) {
                        console.log("User is assigned");
                        activeInstance.user_is_assigned = true;
                        break;
                    }
                }

                activeInstance.resetPhaseCheckboxes();

                setTimeout(function(){
                    activeInstance.loadProjectDetails();
                    activeInstance.getFeedDataForTicket();
                },500);
            }).bind(this);  
        },
        getUserActivities:function(){
            showLoadingOverlay();
            Vue.http.get(baseURL+'/api/user/activities').then(function(response){
                $('body').LoadingOverlay("hide");
                activeInstance.user_activities = response.data;
            }).bind(this);
        },
        toggleTaskAssignment:function(assignee){
            console.log("toggling");
                    if(assignee.selected == true){
                        assignee.selected = false;
                    }
                    else{
                       /*
                        $.each(activeInstance.ticket.assignees,function(ticket_assignee_index,ticket_assignee){
                            ticket_assignee.selected = false;
                        });
                        */
                        assignee.selected = true;
                        activeInstance.task.user_id=assignee.id;
                    }
            console.log(assignee.selected);
        },
        postComment: function(){

            switch(activeInstance.post_type) {
                case "comment_only":
                    activeInstance.sendComment();
                    break;
                case "task":
                    activeInstance.sendTask();
                    break;
                default:
                break;
            }


        },
        /*
        postCommentOldDeleteOneDay: function(){
            if (activeInstance.phase_request) {
                if (activeInstance.phase_request == 'client_approved') {
                    bootbox.confirm({
                        message: "Igényel számlázást a projekt?",
                        buttons: {
                            confirm: {
                                label: 'Igen',
                                className: 'btn-success'
                            },
                            cancel: {
                                label: 'Nem',
                                className: 'btn-danger'
                            }
                        },
                        callback: function(result) {
                            activeInstance.invoice_required = result;

                            activeInstance.sendComment();

                            return;
                        }
                    });
                } else {
                    activeInstance.sendComment();
                }
            } else {
                activeInstance.sendComment();
            }
        },
		postTimeWithoutMessage: function() {
            if (activeInstance.phase_request) {
                if (activeInstance.phase_request == 'client_approved') {
                    bootbox.confirm({
                        message: "Igényel számlázást a projekt?",
                        buttons: {
                            confirm: {
                                label: 'Igen',
                                className: 'btn-success'
                            },
                            cancel: {
                                label: 'Nem',
                                className: 'btn-danger'
                            }
                        },
                        callback: function(result) {
                            activeInstance.invoice_required = result;

                            activeInstance.sendCommentPostWithoutMessage();

                            return;
                        }
                    });
                } else {
                    activeInstance.sendCommentPostWithoutMessage();                    
                }
            } else {
                activeInstance.sendCommentPostWithoutMessage();
            }
        },
        */
        sendTask:function(){
            $('.form-control.error').removeClass('error');
            activeInstance.posting_in_action = true;
            var validation_success=true;
            var message = $('#new_comment_editor').trumbowyg('html');
            message = message.replace(/(?:\u26BD)(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?)*/, "[emoji eltávolítva]")
            message = message.replace(/[\u26BD]/g, "");

            var task_assignments = [];
            $.each(activeInstance.ticket.assignees,function(ticket_assignee_index,ticket_assignee){
                if(ticket_assignee.selected == true){
                    task_assignments.push(ticket_assignee.id);
                }
            });

            //LOAD THE ASSIGNEE DATA TO THE TASK
            activeInstance.task.assignees = task_assignments;

            //VALIDATION
            if(activeInstance.task.assignees.length<1) {
                errorNotification('Nincs felelős kiválasztva.');
                activeInstance.posting_in_action = false;
                validation_success =  false;
            }


            if(activeInstance.worktime_hours=='-1') {
                errorNotification('Az óra mező kitöltése szükséges.');
                $('#field_hour').addClass('error');
                activeInstance.posting_in_action = false;
                validation_success =  false;
            }


            if(activeInstance.worktime_minutes=='-1') {
                errorNotification('A perc mező kitöltése szükséges.');
                $('#field_minute').addClass('error');
                activeInstance.posting_in_action = false;
                validation_success =  false;
            }

            if(activeInstance.activity_id == null) {
                errorNotification('A tevékenység mező kitöltése szükséges.');
                $('#field_activity').addClass('error');
                activeInstance.posting_in_action = false;
                validation_success =  false;
            }

            //VALIDATION
            if(message.length<2){
                errorNotification('A bejegyzés tartalma túl rövid.');
                activeInstance.posting_in_action = false;
                validation_success =  false;
            }

            //VALIDATION
            if(activeInstance.task.title.length<2) {
                errorNotification('A feladat megnevezése túl rövid.');
                $('.assignee_block').find('title').addClass('error');
                activeInstance.posting_in_action = false;
                validation_success =  false;
            }


            //VALIDATION
            if(activeInstance.task.deadline==null) {
                errorNotification('Nincs megadva határidő');
                activeInstance.posting_in_action = false;
                validation_success =  false;
            }

            //VALIDATION
            var task_deadline = moment(activeInstance.task.deadline);
            var now = moment();

            if(task_deadline<now) {
                errorNotification('A határidő a múltban van.');
                activeInstance.posting_in_action = false;
                validation_success =  false;
            }

            //REQUEST
            if(validation_success == true)
            {
                //GET THE FILES
                var files = jQuery.extend(true, {}, activeInstance.dropZoneFiles);

                $.each(files,function(index,file){
                    delete file.file;
                });

                //CHECK IF WE GOT SOME TASK ASSIGNEES -> COLLECT THEM

                showLoadingOverlay();
                axios.post(baseURL+'/api/post/comment', {
                    'message':message,
                    "type":"task",
                    'ticket_id':activeInstance.ticket.id,
                    'project_id':activeInstance.ticket.project_id,
                    'files':files,
                    'task':activeInstance.task,
                    'activity_id':activeInstance.activity_id,
                    'worktime_hours':activeInstance.worktime_hours,
                    'worktime_minutes':activeInstance.worktime_minutes
                })
                    .then(function (response) {
                        $('body').LoadingOverlay("hide");
                        console.log(response);
                        activeInstance.getTicketData();
                        $('#new_comment_editor').trumbowyg('html', "");
                        activeInstance.dropZoneFiles = [];
                        activeInstance.task={
                            "title":"",
                            "user_id":null,
                            "deadline":null
                        };
                        activeInstance.worktime_hours = -1;
                        activeInstance.worktime_minutes = -1;
                        activeInstance.activity_id = 0;
                        activeInstance.activity_id = null;
                        activeInstance.posting_in_action = false;

                    })
                    .catch(function (error) {
                        console.log(error.response.data);
                        $.each(error.response.data,function(key, value){
                            errorNotification(value);
                            console.log(key);
                            $('#'+key).addClass('error');
                        });



                        $('body').LoadingOverlay("hide");
                    });
            }
        },
        sendReply:function(){
            $('.form-control.error').removeClass('error');
            activeInstance.posting_in_action = true;
            var validation_success=true;
            //GET THE MESSAGE
            var message = $('#reply_editor_'+activeInstance.active_comment_id).trumbowyg('html');
            message = message.replace(/(?:\u26BD)(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?)*/, "[emoji eltávolítva]")
            message = message.replace(/[\u26BD]/g, "");

            if(message.length<2) {
                errorNotification('A bejegyzés tartalma túl rövid.');
                activeInstance.posting_in_action = false;
                validation_success =  false;
            }

            if(activeInstance.worktime_hours=='-1') {
                errorNotification('Az óra mező kitöltése szükséges.');
                $('#field_hour_reply_'+activeInstance.active_comment_id).addClass('error');
                activeInstance.posting_in_action = false;
                validation_success =  false;
            }

            if(activeInstance.worktime_minutes=='-1') {
                errorNotification('A perc mező kitöltése szükséges.');
                $('#field_minute_reply_'+activeInstance.active_comment_id).addClass('error');
                activeInstance.posting_in_action = false;
                validation_success =  false;
            }

            if(activeInstance.activity_id == null) {
                errorNotification('A tevékenység mező kitöltése szükséges.');
                $('#field_activity_reply_'+activeInstance.active_comment_id).addClass('error');
                activeInstance.posting_in_action = false;
                validation_success =  false;
            }

            if(validation_success == true)
            {
                //GET THE FILES
                var files = jQuery.extend(true, {}, activeInstance.dropZoneFiles);

                $.each(files,function(index,file){
                    delete file.file;
                });


                showLoadingOverlay();
                axios.post(baseURL+'/api/post/comment', {
                    'message':message,
                    'ticket_id':activeInstance.ticket.id,
                    'project_id':activeInstance.ticket.project_id,
                    'type':"reply",
                    'parent_comment_id':activeInstance.active_comment_id,
                    'activity_id':activeInstance.activity_id,
                    'worktime_hours':activeInstance.worktime_hours,
                    'worktime_minutes':activeInstance.worktime_minutes,
                    //'activity_id':activeInstance.activity_id,
                    //'worktime_hours':activeInstance.worktime_hours,
                    //'worktime_minutes':activeInstance.worktime_minutes,
                    //'has_deadline':activeInstance.comment_deadline_set,
                    //'comment_deadline':activeInstance.comment_deadline,
                    'files':files,
                    //'task_completion':activeInstance.phase_request,
                    //'invoice_required':activeInstance.invoice_required,
                    //'task_assigned':activeInstance.task_assigned,
                    //'task_assignments':taskAssignments
                })
                    .then(function (response) {
                        $('body').LoadingOverlay("hide");
                        console.log(response);
                        activeInstance.getTicketData();
                        $('#reply_editor_'+activeInstance.active_comment_id).trumbowyg('html', "");
                        activeInstance.dropZoneFiles = [];
                        activeInstance.posting_in_action = false;
                        activeInstance.worktime_hours = -1;
                        activeInstance.worktime_minutes = -1;
                        activeInstance.activity_id = 0;
                        activeInstance.comment_deadline = '';
                        activeInstance.comment_deadline_set = false;
                        activeInstance.post_type='';

                    })
                    .catch(function (error) {
                        console.log(error.response.data);
                        $.each(error.response.data,function(key, value){
                            errorNotification(value);
                            console.log(key);
                            $('#'+key).addClass('error');
                        });
                        activeInstance.posting_in_action = false;
                        $('body').LoadingOverlay("hide");
                    });
            }

        },
        sendComment: function() {
            $('.form-control.error').removeClass('error');
            activeInstance.posting_in_action = true;
            var validation_success=true;

            //GET THE MESSAGE
            var message = $('#new_comment_editor').trumbowyg('html');


            message = (""+ message).replace(/(?:\u26BD)(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?)*/, "[emoji eltávolítva]")
            message = (""+message).replace(/[\u26BD]/g, "");

            if(message.length<2) {
                errorNotification('A bejegyzés tartalma túl rövid.');
                activeInstance.posting_in_action = false;
                validation_success =  false;
            }


            if(activeInstance.worktime_hours=='-1') {
                errorNotification('Az óra mező kitöltése szükséges.');
                $('#field_hour').addClass('error');
                activeInstance.posting_in_action = false;
                validation_success =  false;
            }


            if(activeInstance.worktime_minutes=='-1') {
                errorNotification('A perc mező kitöltése szükséges.');
                $('#field_minute').addClass('error');
                activeInstance.posting_in_action = false;
                validation_success =  false;
            }

            if(activeInstance.activity_id == null) {
                errorNotification('A tevékenység mező kitöltése szükséges.');
                $('#field_activity').addClass('error');
                activeInstance.posting_in_action = false;
                validation_success =  false;
            }


            if(validation_success == true)
            {
                //GET THE FILES
                var files = jQuery.extend(true, {}, activeInstance.dropZoneFiles);

                $.each(files,function(index,file){
                    delete file.file;
                });



                //CHECK IF WE GOT SOME TASK ASSIGNEES -> COLLECT THEM
                var taskAssignments = [];
                activeInstance.ticket.assignees.forEach(function(assignee){
                    if(assignee.selected==true){
                        taskAssignments.push(assignee.id);
                    }
                });

                showLoadingOverlay();
                axios.post(baseURL+'/api/post/comment', {
                    'message':message,
                    'ticket_id':activeInstance.ticket.id,
                    'project_id':activeInstance.ticket.project_id,
                    'type':"comment",
                    'activity_id':activeInstance.activity_id,
                    'worktime_hours':activeInstance.worktime_hours,
                    'worktime_minutes':activeInstance.worktime_minutes,
                    //'has_deadline':activeInstance.comment_deadline_set,
                    //'comment_deadline':activeInstance.comment_deadline,
                    'files':files,
                    //'task_completion':activeInstance.phase_request,
                    //'invoice_required':activeInstance.invoice_required,
                    //'task_assigned':activeInstance.task_assigned,
                    //'task_assignments':taskAssignments
                })
                .then(function (response) {
                    $('body').LoadingOverlay("hide");
                    console.log(response);
                    activeInstance.getTicketData();
                    $('#new_comment_editor').trumbowyg('html', "");
                    activeInstance.dropZoneFiles = [];
                    activeInstance.posting_in_action = false;
                    activeInstance.worktime_hours = -1;
                    activeInstance.worktime_minutes = -1;
                    activeInstance.activity_id = 0;
                    activeInstance.activity_id = null;
                    activeInstance.comment_deadline = '';
                    activeInstance.comment_deadline_set = false;

                })
                .catch(function (error) {
                    console.log(error.response.data);
                    $.each(error.response.data,function(key, value){
                        errorNotification(value);
                        console.log(key);
                        $('#'+key).addClass('error');
                    });
                    activeInstance.posting_in_action = false;
                    $('body').LoadingOverlay("hide");
                });
            }
        },
        sendCommentPostWithoutMessage: function() {



            activeInstance.posting_in_action = true;
			var validation_success=true;
			
			if(activeInstance.worktime_hours=='-1') {
                errorNotification('Az óra mező kitöltése szükséges.');
                $('#field_hour').addClass('error');
                activeInstance.posting_in_action = false;
                validation_success =  false;
            }

            if(activeInstance.worktime_minutes=='-1') {
                errorNotification('A perc mező kitöltése szükséges.');
                $('#field_minute').addClass('error');
                activeInstance.posting_in_action = false;
                validation_success =  false;
            }

            if(activeInstance.activity_id == null) {
                errorNotification('A tevékenység mező kitöltése szükséges.');
                $('#field_activity').addClass('error');
                activeInstance.posting_in_action = false;
                validation_success =  false;
            }

            if(validation_success == true)
            {

                showLoadingOverlay();
                axios.post(baseURL+'/api/post/comment/without/message', {
                    'ticket_id':activeInstance.ticket.id,
                    'project_id':activeInstance.ticket.project_id,
                    'activity_id':activeInstance.activity_id,
                    'worktime_hours':activeInstance.worktime_hours,
                    'worktime_minutes':activeInstance.worktime_minutes,
                    'task_completion':activeInstance.phase_request,
                    'invoice_required':activeInstance.invoice_required,
                    "type":"comment"
                })
                .then(function (response) {
                    $('body').LoadingOverlay("hide");
                    console.log(response);
                    activeInstance.getTicketData();
                    $('#new_comment_editor').trumbowyg('html', "");
                    activeInstance.dropZoneFiles = [];
                    activeInstance.posting_in_action = false;
                    activeInstance.worktime_hours = -1;
                    activeInstance.worktime_minutes = -1;
                    activeInstance.activity_id = 0;
                    activeInstance.comment_deadline = '';
                    activeInstance.comment_deadline_set = false;
                })
                .catch(function (error) {
                    console.log(error.response.data);
                    $.each(error.response.data,function(key, value){
                        errorNotification(value);
                        console.log(key);
                        $('#'+key).addClass('error');
                    });
                    activeInstance.posting_in_action = false;
                    $('body').LoadingOverlay("hide");
                });

                //GET THE FILES
                var files = jQuery.extend(true, {}, activeInstance.dropZoneFiles);

                $.each(files,function(index,file){
                    delete file.file;
                });
            }
        },
        resetPhaseCheckboxes: function() {
            $(".phase_checkbox").prop("checked", false);
        },
        phaseCheckboxChanged: function(event) {



            console.log(event);
            var is_checked = $(event.target).is(':checked');

            if(is_checked){

                var machine_name = event.target.getAttribute("machine-name");
                console.log(machine_name);

                $(activeInstance.phase_list).each(function(index, record){
                    if (record.machine_name != machine_name) {
                        record.selected = false;
                    } else {
                        activeInstance.phase_request = machine_name;
                    }
                });

            }
            else{
                activeInstance.phase_request = null;
            }


        },
        loadPhaseList: function() {
            showLoadingOverlay();
            axios.get(baseURL+'/api/ticket/phase/list')
            .then(function (response) {
                $('body').LoadingOverlay("hide");

                $(response.data).each(function(index, record){
                    record.selected = false;
                   console.log(record);
                });

                activeInstance.phase_list = response.data.sort(function(a,b) {
                    return a.order > b.order;
                });
            })
            .catch(function (error) {
                $('body').LoadingOverlay("hide");
                console.log(error);

            });
        }
    }
});